import React, { useRef, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { dataStatColumns } from '../../../utils/helpers/table/tableHelper';
import FilterFormMonitoring from '../filter/FilterFormMonitoring';
import { TableStyles } from './tableCss';
import { Toast } from 'primereact/toast';
import Loader from '../../common/Loader';
import {
  getStatistic,
  renderTableData,
} from '../../../utils/helpers/table/TableMonitoringHelper';

const TableMonitoring = () => {
  const datcol: any = dataStatColumns;
  const [statiticList, setStatiticList] = useState([]);
  const toastInf = useRef<any>(null);
  const [loading, setLoading] = React.useState(false);

  const callBack = (
    startDate: any,
    endDate: any,
    objet: any,
    region: any,
    type: any,
    classmeasure: any,
  ) => {
    if (startDate && endDate) {
      getStatistic(
        startDate,
        endDate,
        objet || '',
        region || '',
        type || '',
        classmeasure || '',
        setLoading,
        setStatiticList,
        toastInf,
      );
    }
  };
  return (
    <Container className=''>
      <Styles />
      <Toast ref={toastInf} />
      {loading ? <Loader IsVisible={true} /> : null}
      <FilterFormMonitoring monitoringCallback={callBack} />
      <Card className='data-table' automatedTestId='data-table-id'>
        {renderTableData(datcol, statiticList)}
      </Card>
    </Container>
  );
};

const Styles = TableStyles;
export default TableMonitoring;
